import React from 'react';
import styled from 'styled-components';
import { withDefaultProps } from '../utils/reactUtils';

const Wrapper = styled.div`
	margin: 0 !important;
	font-weight: 500;
	font-size: 14px;
	
	label {
		font-size: 15px;
	}
`;

let currentId = 0;

interface SwitchProps {
	id: string | number;
	on: string;
	off: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled: boolean;
}

const switchDefaultProps: Partial<SwitchProps> = {
	checked: false
};

const Switch = withDefaultProps(switchDefaultProps, (props: SwitchProps) => {
	const switchId = props.id || `switch${currentId}`;
	const { on, off, checked, onChange, disabled } = props;
	currentId += 1;
	return (
		<Wrapper className="switch round">
			<input disabled={disabled} className="switch-input" id={String(switchId)} type="checkbox" checked={checked} onChange={(e) => !disabled && onChange && onChange(e.target.checked)} />
			<label className="switch-paddle" htmlFor={String(switchId)}>
				<span className="switch-active" aria-hidden="true">
					{on}
				</span>
				<span className="switch-inactive" aria-hidden="true">
					{off}
				</span>
			</label>
		</Wrapper>
	);
});

export const YesNoSwitch: React.FC<SwitchProps> = (props: SwitchProps) => {
	const { on, off, ...otherProps } = props;
	return <Switch on={on || 'Kyllä'} off={off || 'Ei'} {...otherProps} />;
};
